// src/services/BranchService.js
import { get, post, put, del } from '@/security/Axios';

const BASE = `/branch`;

export const headersFor = (opts) => {
  const h = {};
  if (opts && opts.companyId) h['X-Company-Id'] = opts.companyId;
  if (opts && opts.all) h['X-Ignore-Tenant'] = '1'; // backend also checks ?all=1
  return Object.keys(h).length ? { headers: h } : {};
};

function parseList(raw) {
  const d = raw && raw.data != null ? raw.data : raw;
  if (d && Array.isArray(d.data)) return d.data;
  if (d && Array.isArray(d.items)) return d.items;
  if (d && Array.isArray(d.results)) return d.results;
  if (Array.isArray(d)) return d;
  return [];
}

export const fetchBranches = async (opts) => {
  const q = opts && opts.all ? '?all=1' : '';
  const res = await get(`${BASE}/my${q}`, headersFor(opts));
  return parseList(res);
};

export const createBranch = (payload, companyId) =>
  post(`${BASE}`, payload, headersFor({ companyId }));

export const updateBranch = (id, payload, companyId) =>
  put(`${BASE}/${id}`, payload, headersFor({ companyId }));

export const deleteBranch = (id, companyId) =>
  del(`${BASE}/${id}`, headersFor({ companyId }));
